import { type ReduxUser, type ContentObjectRedux } from 'models';
import { ShareContentObject as ShareContentObjectOld } from 'old/atoms/share-content-object';
import { useOnCreateObject, useOnRequestEventDetail } from './hooks';

type P = {
  item: ContentObjectRedux;
  viewer: ReduxUser;
  onClose: () => void;
};

const ShareContentObject = ({ item, viewer, onClose }: P) => {
  const onRequestEventDetail = useOnRequestEventDetail();
  const onCreateObject = useOnCreateObject();

  return (
    <ShareContentObjectOld
      item={item}
      viewer={viewer}
      onClose={onClose}
      onCreateObject={onCreateObject}
      onRequestEventDetail={onRequestEventDetail}
    />
  );
};

export default ShareContentObject;
